export const getExperimentLogPayload = (logData) => {
    return JSON.parse(JSON.stringify({
        product: logData.product,
        feature: logData.feature,
        experimentKey: logData.experimentKey,
        experimentVariationId: logData.experimentVariationId,
        featureValue: logData.featureValue,
        userId: logData === null || logData === void 0 ? void 0 : logData.userId,
        cUserId: logData === null || logData === void 0 ? void 0 : logData.cUserId,
        id: logData === null || logData === void 0 ? void 0 : logData.id,
        email: logData === null || logData === void 0 ? void 0 : logData.email,
        uuid: logData === null || logData === void 0 ? void 0 : logData.uuid,
        jobId: logData === null || logData === void 0 ? void 0 : logData.jobId,
        cf_id: logData === null || logData === void 0 ? void 0 : logData.cf_id,
        url: logData === null || logData === void 0 ? void 0 : logData.url,
        visitorId: logData === null || logData === void 0 ? void 0 : logData.visitorId,
        sessionId: logData === null || logData === void 0 ? void 0 : logData.sessionId,
        category: logData === null || logData === void 0 ? void 0 : logData.category,
        jobsCount: logData === null || logData === void 0 ? void 0 : logData.jobsCount,
        singleUserForAllConnectedJobs: logData === null || logData === void 0 ? void 0 : logData.singleUserForAllConnectedJobs,
    }));
};
//# sourceMappingURL=getExperimentLogData.js.map